"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressDetailsPanel = void 0;
var MultimatchAddressModal_cms_1 = require("../components/cards/MultimatchAddressModal/MultimatchAddressModal.cms");
var addressformcard_cms_1 = require("../components/cards/AddressFormCard/addressformcard.cms");
var addressDetailsPanel_cms_1 = require("../components/panels/AddressDetailsPanel/addressDetailsPanel.cms");
var serviceNotAvailableCard_cms_1 = require("../components/shared/ServiceNotAvailableCard/serviceNotAvailableCard.cms");
var AddressDetailsPanel = /** @class */ (function () {
    function AddressDetailsPanel() {
        this.addressForm = new addressformcard_cms_1.AddressFormCardCms();
        this.multimatchAddressModal = new MultimatchAddressModal_cms_1.MultimatchAddressModalCms();
        this.panelContent = new addressDetailsPanel_cms_1.AddressDetailsPanelCms();
        this.serviceCard = new serviceNotAvailableCard_cms_1.ServiceNotAvailableCardCms();
    }
    return AddressDetailsPanel;
}());
exports.AddressDetailsPanel = AddressDetailsPanel;
//# sourceMappingURL=AddressDetailPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/cms/AddressDetailPanel.cms.js
// module id = 1985
// module chunks = 8